import { QuestionBase } from './question-base.model';
import moment from 'proxies/dayjs';

export class TimePickerQuestion extends QuestionBase<any> {
    controlType = 'timepicker';
    timePickerSeconds: boolean;
    timePickerIncrement: string;
    timePicker24Hour: boolean;
    locale: any;
    selected: boolean;
    minDateNumber: number;
    minDateUnit: any;
    maxDateNumber: number;
    maxDateUnit: any;
    visible: boolean;
    startOfDay: boolean = false;
    disabled: boolean;
    constructor(options: {} = {}) {
        super(options);
        this.locale = (options['locale'] == undefined) ? { format: 'HH:mm:ss' } : options['locale'];
        this.timePickerSeconds = (options['timePickerSeconds'] == undefined) ? true : options['timePickerSeconds'];
        this.timePickerIncrement = (options['timePickerIncrement'] == undefined) ? "1" : options['timePickerIncrement'];
        this.timePicker24Hour = (options['timePicker24Hour'] == undefined) ? true : options['timePicker24Hour'];
        this.value = (options['value'] == undefined && options['selected'] == undefined) ? moment(moment().startOf('day')).unix().valueOf() * 1000 : options['value'];
        this.selected = (options['selected'] == undefined) ? false : options['selected'];
        this.minDateNumber = options['minDateNumber'];
        this.minDateUnit = options['minDateUnit'];
        this.maxDateNumber = options['maxDateNumber'];
        this.maxDateUnit = options['maxDateUnit'];
        this.disabled = options['disabled']==undefined?false:options['disabled'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.startOfDay = (options['startOfDay'] == undefined)? false: options['startOfDay'];
    }
}